// extracted by mini-css-extract-plugin
export default {"container":"Search_container__8rG0x","content":"Search_content__RjjTj","children":"Search_children__TqJdI"};